import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { resetPassword } from "../api";
import { Row, Button, Form, Label, Col, Input, Container } from "reactstrap";

const ResetPassword = () => {
    const { uid, token } = useParams();
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError("");
        setMessage("");

        if (newPassword !== confirmPassword) {
            setError("Passwords do not match.");
            setSubmitting(false);
            return;
        }

        try {
            const data = await resetPassword(uid, token, newPassword);
            setMessage(data.detail || "Password reset successful.");
            setNewPassword("");
            setConfirmPassword("");
        } catch (err) {
            const detail = err?.response?.data?.detail || "Unable to reset password.";
            setError(Array.isArray(detail) ? detail.join(" ") : detail);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Container className="contain login-page auth-page d-flex justify-content-center align-items-center vh-100">
            <Row className="w-100 justify-content-center">
                <Col xs={12} sm={10} md={8} lg={5}>
                    <Form onSubmit={handleSubmit} className="auth-panel">
                        <Row className="g-3 flex-column text-center">
                            <Col>
                                <img
                                    src="/icon-lfx-192.svg"
                                    alt="Limitless FX"
                                    className="login-app-icon"
                                />
                            </Col>
                            <Col>
                                <strong className="login_header">Reset Password</strong>
                            </Col>
                            <Col>
                                <Label className="visually-hidden" for="new-password">
                                    New Password
                                </Label>
                                <Input
                                    id="new-password"
                                    name="new-password"
                                    placeholder="New Password"
                                    type="password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    required
                                />
                            </Col>
                            <Col>
                                <Label className="visually-hidden" for="confirm-password">
                                    Confirm Password
                                </Label>
                                <Input
                                    id="confirm-password"
                                    name="confirm-password"
                                    placeholder="Confirm New Password"
                                    type="password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            </Col>
                            {message && <Col className="auth-success small">{message}</Col>}
                            {error && <Col className="auth-error small">{error}</Col>}
                            <Col>
                                <Button type="submit" disabled={submitting} className="brand-action-button">
                                    {submitting ? "Resetting..." : "Reset Password"}
                                </Button>
                            </Col>
                            <Col>
                                <Link to="/login" className="auth-link">Back to Login</Link>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default ResetPassword;
